import { useQuery } from "@tanstack/react-query";
import { salonProfileQuery } from "@/features/salon";
import { type Theme, useResolvedTheme } from "@/lib/theme.store";

/**
 * The theme on screen: the customer's choice, else the salon's (FR-SA-189). Until the profile
 * arrives the phone decides, so a slow connection shows the phone's look rather than a flash of the
 * opposite one.
 */
export function usePageTheme(): Theme {
  const { data } = useQuery(salonProfileQuery());
  const salon = data?.pageTheme;
  return useResolvedTheme(salon === "Dark" ? "dark" : salon === "Light" ? "light" : null);
}
